export function createConcurrencyLimiter(concurrency) {
    if (!Number.isInteger(concurrency) || concurrency < 1) {
        throw new Error("concurrency must be a positive integer");
    }
    let activeCount = 0;
    const waiters = [];
    const acquire = async () => {
        if (activeCount < concurrency) {
            activeCount += 1;
            return;
        }
        await new Promise((resolve) => {
            waiters.push(resolve);
        });
    };
    const release = () => {
        const next = waiters.shift();
        if (next)
            next();
        else
            activeCount -= 1;
    };
    return {
        async run(task) {
            await acquire();
            try {
                return await task();
            }
            finally {
                release();
            }
        },
    };
}
export async function mapSettledWithConcurrency(items, concurrency, mapper) {
    if (!Number.isInteger(concurrency) || concurrency < 1) {
        throw new Error("concurrency must be a positive integer");
    }
    const results = new Array(items.length);
    let nextIndex = 0;
    const worker = async () => {
        while (nextIndex < items.length) {
            const index = nextIndex;
            nextIndex += 1;
            try {
                results[index] = { status: "fulfilled", value: await mapper(items[index], index) };
            }
            catch (reason) {
                results[index] = { status: "rejected", reason };
            }
        }
    };
    const workerCount = Math.min(concurrency, items.length);
    await Promise.all(Array.from({ length: workerCount }, () => worker()));
    return results;
}
//# sourceMappingURL=async.js.map